export default __webpack_public_path__ + "static/media/2_icon1B.d1ea3c24.png";